import { Button, Grid, TextField } from "@material-ui/core";
import LabelsContext from "../../../lang/LabelsContext";
import AddReviewerService, { AddReviewerServiceType } from "./AddReviewerService";
import { Form, Formik } from "formik";
import { DialogActions, DialogContent } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Dialog, DialogTitle } from "@material-ui/core";
import useStyles from "./AddReviewerStyle";
import * as yup from "yup";
import Password from "../../system/password/Password";

const orcidRegExp = /[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]/;

export default function AddReviewer({ save, label }: any) {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const { countryList, handleOpenDialog, handleCloseDialog, openDialog }: AddReviewerServiceType = AddReviewerService();

  const validationSchema = yup.object().shape({
    firstName: yup.string().required(Labels.FIRSTNAME_REQUIRED),
    lastName: yup.string().required(Labels.LASTNAME_REQUIRED),
    orcid: yup.string().matches(orcidRegExp, "Orcid not valid (xxxx-xxxx-xxxx-xxxx)"),
    email: yup.string().required(Labels.EMAIL_REQUIRED).email(),
    emailRepeat: yup
      .mixed()
      .test("match", Labels.EMAIL_DO_NOT_MATCH, function (email) {
        return email === this.parent.email;
      })
      .required(Labels.EMAIL_REPEAT_REQUIRED),
    password: yup.string().required(Labels.PASSWORD_REQUIRED),
    passwordRepeat: yup
      .mixed()
      .test("match", Labels.PASSWORDS_DO_NOT_MATCH, function (password) {
        return password === this.parent.password;
      })
      .required(Labels.PASSWORD_REPEAT_REQUIRED),
  });

  return (
    <>
      <Button variant="contained" onClick={handleOpenDialog} color="primary" className={classes.addReviewer}>
        {label}
      </Button>
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{label}</DialogTitle>
        <Formik
          initialValues={{
            firstName: "",
            middleName: "",
            lastName: "",
            title: "",
            orcid: "",
            country: "",
            email: "",
            emailRepeat: "",
            password: "",
            passwordRepeat: "",
            areasOfExpertise: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            save(values);
            handleCloseDialog();
          }}
        >
          {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="firstName"
                      name="firstName"
                      label={Labels.FIRSTNAME}
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.firstName && Boolean(errors.firstName)}
                      helperText={touched.firstName && errors.firstName}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="middleName"
                      name="middleName"
                      label={Labels.MIDDLENAME}
                      value={values.middleName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.middleName && Boolean(errors.middleName)}
                      helperText={touched.middleName && errors.middleName}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="lastName"
                      name="lastName"
                      label={Labels.LASTNAME}
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.lastName && Boolean(errors.lastName)}
                      helperText={touched.lastName && errors.lastName}
                      fullWidth
                      required
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="orcid"
                      placeholder={Labels.ORCID_MASK}
                      name="orcid"
                      label={Labels.ORCID}
                      value={values.orcid}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.orcid && Boolean(errors.orcid)}
                      helperText={touched.orcid && errors.orcid}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="title"
                      name="title"
                      label={Labels.TITLE}
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.title && Boolean(errors.title)}
                      helperText={touched.title && errors.title}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {countryList && (
                      <Autocomplete
                        options={countryList}
                        onChange={(event, newValue) => {
                          setFieldValue("country", newValue.countryName);
                        }}
                        getOptionLabel={(option: any) => option.countryName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            id="country"
                            name="country"
                            value={values.country}
                            onBlur={handleBlur}
                            label={Labels.COUNTRY}
                            error={touched.country && Boolean(errors.country)}
                            helperText={touched.country && errors.country}
                            fullWidth
                          />
                        )}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="email"
                      name="email"
                      autoComplete="new-password"
                      label={Labels.EMAIL}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="emailRepeat"
                      name="emailRepeat"
                      autoComplete="new-password"
                      label={Labels.REPEAT_EMAIL_ADDRESS}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.emailRepeat && Boolean(errors.emailRepeat)}
                      helperText={touched.emailRepeat && errors.emailRepeat}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Password
                      label={Labels.PASSWORD}
                      name="password"
                      statePassword={values.password}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touchedPassword={touched.password}
                      errorsPassword={errors.password}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Password
                      label={Labels.REPEAT_PASSWORD}
                      name="passwordRepeat"
                      statePassword={values.passwordRepeat}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touchedPassword={touched.passwordRepeat}
                      errorsPassword={errors.passwordRepeat}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      id="areasOfExpertise"
                      name="areasOfExpertise"
                      label={Labels.AREAS_OF_EXPERTISE}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.areasOfExpertise && Boolean(errors.areasOfExpertise)}
                      helperText={touched.areasOfExpertise && errors.areasOfExpertise}
                      fullWidth
                      multiline
                      rows={5}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                  {Labels.CANCEL}
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  {Labels.SAVE}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
}
